import React, {useState} from 'react';

import {hooks} from '../hooks';

type Props = {
  className: string;
  label?: string;
};

export const PwaInstallButton: React.FC<Props> = ({
  className,
  label = 'İndir',
}) => {
  const {install, isInstalled, isIos} = hooks.usePwaInstall();
  const [showHelp, setShowHelp] = useState(false);

  if (isInstalled) return null;

  const handleInstall = async () => {
    const outcome = await install();

    if (outcome === 'manual' || outcome === 'unavailable') {
      setShowHelp(true);
    }
  };

  return (
    <>
      <button
        className={className}
        onClick={handleInstall}
        type='button'
      >
        {label}
      </button>
      {showHelp && (
        <div
          className='install-help'
          role='dialog'
          aria-modal='true'
        >
          <div className='install-help__card'>
            <span className='install-help__eyebrow'>Uygulama</span>
            <h3>Telefona indir</h3>
            <p>
              {isIos
                ? 'Safari paylaş menüsünden Ana Ekrana Ekle seçeneğini kullanın.'
                : 'Tarayıcı menüsündeki uygulamayı yükle veya ana ekrana ekle seçeneğini kullanın.'}
            </p>
            <button
              className='salon-button salon-button--dark'
              onClick={() => setShowHelp(false)}
              type='button'
            >
              Tamam
            </button>
          </div>
        </div>
      )}
    </>
  );
};
